﻿import {Button, Modal} from "antd";
import {IProjectRisk} from "@/containers/RisksAndIssues/interfaces";
import HistoryLogTable from "@/components/History/HistoryLogTable";

interface IProps {
    open: boolean;
    onClose: () => void;
    projectRiskId: string | undefined;
}

export const RiskHistoryModal = ({projectRiskId, open, onClose}: IProps) => {
    if (projectRiskId === undefined) {
        return null;
    }
    return (
        <Modal
            open={open}
            title={"Risk History"}
            onCancel={onClose}
            style={{ minWidth: "50%" }}
            footer={[
                <Button onClick={onClose}>
                    Close
                </Button>]}
            >
            <HistoryLogTable parentEntityId={projectRiskId} pageSize={10} />
        </Modal>
    )
}